import { render, staticRenderFns } from "./waterSaving.vue?vue&type=template&id=c937a050&scoped=true&"
import script from "./waterSaving.vue?vue&type=script&lang=js&"
export * from "./waterSaving.vue?vue&type=script&lang=js&"
import style0 from "./waterSaving.vue?vue&type=style&index=0&id=c937a050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c937a050",
  null
  
)

export default component.exports